module.exports = __webpack_public_path__ + "img/normal-buy-hen.4a8514d1.png";